import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsAPI } from '../lib/api';

/**
 * Silently tracks a visit on each route change (public pages only).
 * Deduplicates per route per session via sessionStorage.
 */
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip admin/login/register tracking
    if (
      location.pathname.startsWith('/admin') ||
      location.pathname.startsWith('/login') ||
      location.pathname.startsWith('/register')
    ) {
      return;
    }

    // Dedup per path per session
    const key = `visit-${location.pathname}`;
    if (sessionStorage.getItem(key) === '1') return;

    analyticsAPI.trackVisit().catch(() => {});
    sessionStorage.setItem(key, '1');
  }, [location.pathname]);

  return null;
};

export default PageTracker;
